import moment from 'moment';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import Swal from "sweetalert2";
//import DataService from '../../../Services/DataService';

const STORAGE_KEY = 'room_bookings_v2';

const DAY_NAMES = {
    0: { full: 'الأحد', short: 'أحد' },
    1: { full: 'الإثنين', short: 'إثنين' },
    2: { full: 'الثلاثاء', short: 'ثلاثاء' },
    3: { full: 'الأربعاء', short: 'أربعاء' },
    4: { full: 'الخميس', short: 'خميس' },
    5: { full: 'الجمعة', short: 'جمعة' },
    6: { full: 'السبت', short: 'سبت' },
};

export default {
    name: 'RoomBookingWizard',
    mixins: [HelperMixin],

    filters: {
        moment: function (date) {
            if (!date) return 'فارغ';
            return moment(date).format('DD/MM/YYYY');
        }
    },

    data() {
        return {
            step: 1,

            // ─── بيانات الـ API ───
            rooms: [],
            slotsForDay: [],

            // ─── حالات التحميل ───
            isLoadingRooms: false,
            isLoadingSchedules: false,

            // ─── التحديد الحالي ───
            selectedRoom: null,
            selectedDay: null,
            selectedSlot: null,

            // ─── الأيام والحجوزات ───
            weekDays: [],
            weekRangeLabel: '',
            bookings: [],
            lastBooking: null,

            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Info: [],
        };
    },

    async created() {
        this.InitializeWeek();
        this.LoadBookings();
        await this.fetchRooms();
        this.GetInfo(this.pageNo);
    },

    methods: {
        // ─── 1. دوال الاتصال بالـ API ────────────────────────────────
        async fetchRooms() {
            this.isLoadingRooms = true;
            try {
                const response = await this.$http.GetAllRooms();
                this.rooms = response.data;
            } catch (error) {
                console.error("Error fetching rooms:", error);
                this.$helper.ShowMessage('error', 'خطأ', 'فشل الاتصال بقاعدة البيانات لجلب الغرف');
            } finally {
                this.isLoadingRooms = false;
            }
        },

        // ─── 2. التنقل والتحكم في الواجهة ───────────────────────────

        // عند اختيار الغرفة -> ننتقل مباشرة لاختيار اليوم دون جلب المواعيد
        selectRoom(room) {
            this.selectedRoom = room;
            this.selectedDay = null;
            this.selectedSlot = null;
            this.slotsForDay = [];
            this.step = 2; // الانتقال للخطوة 2 (اختيار اليوم)
        },

        // عند اختيار اليوم -> نقوم بجلب المواعيد من الـ API
        async selectDay(day) {
            this.selectedDay = day;
            this.selectedSlot = null;
            this.slotsForDay = [];

            this.isLoadingSchedules = true;
            this.$blockUI.Start();

            try {
                const response = await this.$http.GetSchedulesByRoomDay(this.selectedRoom.id, day.dateStr);
                this.slotsForDay = response.data;

                if (this.slotsForDay.length === 0) {
                    this.$helper.ShowMessage('warning', 'تنبيه', 'لا توجد مواعيد متاحة لهذه الغرفة في هذا اليوم');
                    this.selectedDay = null; // إعادة تعيين اليوم
                    return;
                }

                this.step = 3; // الانتقال للخطوة 3 (اختيار الوقت)
            } catch (error) {
                console.error("Error fetching schedules:", error);
                this.$helper.ShowMessage('error', 'خطأ', 'لم نتمكن من جلب مواعيد الحجز');
                this.selectedDay = null;
            } finally {
                this.isLoadingSchedules = false;
                this.$blockUI.Stop();
            }
        },

        selectSlot(slot) {
            if (this.isBooked(slot)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'هذا الموعد محجوز بالكامل');
                return;
            }
            this.selectedSlot = slot;
        },

        goConfirm() {
            if (!this.selectedSlot || !this.selectedRoom) return;
            this.step = 4;
        },
         getDayName(index) {
    return DAY_NAMES[index]?.full || '';
},
        goBack() {
            this.step = 3;
        },

        resetAll() {
            this.selectedRoom = null;
            this.selectedDay = null;
            this.selectedSlot = null;
            this.slotsForDay = [];
            this.step = 1;
        },

        // ─── 3. منطق السعة والحجوزات ────────────────────────────────
        LoadBookings() {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                this.bookings = JSON.parse(saved);
            }
        },

        saveBookings() {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(this.bookings));
            } catch (e) {
                console.error('Storage error', e);
            }
        },

        isBooked(slot, dateStr) {
            const ds = dateStr || (this.selectedDay && this.selectedDay.dateStr);
            const rId = this.selectedRoom ? this.selectedRoom.id : null;
            if (!ds || !rId) return false;

            const slotBookings = this.bookings.filter(b => b.roomId === rId && b.dateStr === ds && b.slotId === slot.id);
            return slotBookings.length >= slot.capacity;
        },

        remainingCapacity(slot, dateStr) {
            const ds = dateStr || (this.selectedDay && this.selectedDay.dateStr);
            const rId = this.selectedRoom ? this.selectedRoom.id : null;
            if (!ds || !rId) return slot.capacity;

            const used = this.bookings.filter(b => b.roomId === rId && b.dateStr === ds && b.slotId === slot.id).length;
            return Math.max(0, slot.capacity - used);
        },

        capacityPct(slot, dateStr) {
            const remaining = this.remainingCapacity(slot, dateStr);
            return Math.round((remaining / slot.capacity) * 100);
        },

        // ─── 4. تأكيد الحجز ─────────────────────────────────────────
        async confirmBooking() {
            if (!this.selectedDay || !this.selectedSlot || !this.selectedRoom) return;

            if (this.isBooked(this.selectedSlot)) {
                this.$helper.ShowMessage('error', 'خطأ', 'عذراً! تم حجز هذا الموعد للتو');
                this.step = 3;
                return;
            }

            this.$blockUI.Start();

            try {
                const bookingData = {
                    roomId: this.selectedRoom.id,
                    BookingDate: this.selectedDay.dateStr,
                    RoomScheduleId: this.selectedSlot.id,
                };
                this.$http.AddBookingInstructors(bookingData)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);

                        // حفظ آخر حجز لعرضه في شاشة النجاح
                        this.lastBooking = {
                            roomName: this.selectedRoom.name,
                            roomId: this.selectedRoom.id,
                            dayLabel: this.selectedDay.fullLabel,
                            slotTime: `${this.selectedSlot.startTime} - ${this.selectedSlot.endTime}`,
                            dateStr: this.selectedDay.dateStr,
                            slotId: this.selectedSlot.id,
                        };

                        this.step = 5;
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة',
                            err.response?.data || 'حدث خطأ غير متوقع');
                    });
                // حفظ محلي مؤقت (لحين تفعيل API الحفظ الحقيقي)
                //setTimeout(() => {
                //    bookingData.id = Date.now();
                //    this.bookings.push(bookingData);
                //    this.saveBookings();

                //    this.lastBooking = {
                //        roomName: this.selectedRoom.name,
                //        roomId: this.selectedRoom.id,
                //        dayLabel: this.selectedDay.fullLabel,
                //        slotTime: this.selectedSlot.label,
                //        dateStr: this.selectedDay.dateStr,
                //        slotId: this.selectedSlot.id,
                //    };

                //    this.step = 5;
                //    this.$blockUI.Stop();
                //    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تأكيد حجزك بنجاح!');
                //}, 800);

            } catch (error) {
                console.error("Booking failed:", error);
                this.$blockUI.Stop();
                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ أثناء تأكيد الحجز');
            }
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) this.pageNo = 1;

            if (!this.Search) this.$blockUI.Start();
            this.$http.GetBookingsInstructors(
                this.pageNo,
                this.pageSize,
            )
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.pages = 0;
                });
        },
        async bookSameTimeNextWeek() {
            if (!this.lastBooking) return;

            const lastDate = this.parseDateStr(this.lastBooking.dateStr);
            const nextDate = this.addDays(lastDate, 7);
            const nextDateStr = this.formatDateLocal(nextDate);

            const slot = this.slotsForDay.find(s => s.id === this.lastBooking.slotId);
            if (!slot) return;

            const used = this.bookings.filter(b => b.roomId === this.lastBooking.roomId && b.dateStr === nextDateStr && b.slotId === slot.id).length;
            if (used >= slot.capacity) {
                this.$helper.ShowMessage('warning', 'عذراً', 'الموعد نفسه غير متاح الأسبوع القادم نظراً لاكتمال العدد');
                return;
            }

            this.$blockUI.Start();

            try {
                setTimeout(() => {
                    const bookingData = {
                        id: Date.now(),
                        roomId: this.lastBooking.roomId,
                        dateStr: nextDateStr,
                        slotId: slot.id
                    };

                    this.bookings.push(bookingData);
                    this.saveBookings();

                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الحجز للأسبوع التالي بنجاح');
                    this.resetAll();
                }, 800);

            } catch (error) {
                this.$blockUI.Stop();
                this.$helper.ShowMessage('error', 'خطأ', 'حدث خطأ أثناء إتمام الحجز');
            }
        },

        // ─── 5. مساعِدات التواريخ ──────────────────────────────────
        formatDateLocal(d) {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        addDays(d, n) {
            const r = new Date(d);
            r.setDate(r.getDate() + n);
            return r;
        },

        parseDateStr(str) {
            const [y, m, day] = str.split('-').map(Number);
            return new Date(y, m - 1, day);
        },

        InitializeWeek() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const dayOfWeek = today.getDay();
            const daysUntilSat = (6 - dayOfWeek + 7) % 7 || 7;
            const nextSat = this.addDays(today, daysUntilSat);

            const weekDays = [];
            for (let i = 0; i < 7; i++) {
                const d = this.addDays(nextSat, i);
                const dow = d.getDay();
                weekDays.push({
                    date: d,
                    dateStr: this.formatDateLocal(d),
                    dayNum: d.getDate(),
                    shortName: DAY_NAMES[dow].short,
                    fullLabel: `${DAY_NAMES[dow].full} ${d.getDate()}/${d.getMonth() + 1}`
                });
            }

            this.weekDays = weekDays;
            const s = weekDays[0];
            const e = weekDays[6];
            this.weekRangeLabel = `${s.dayNum}/${s.date.getMonth() + 1} — ${e.dayNum}/${e.date.getMonth() + 1}`;
        },
        CancelBooking(Id) {
            Swal.fire({
                title: 'تأكيد الإلغاء',
                text: 'هل أنت متأكد من إلغاء هذا الحجز؟',
                icon: 'warning',
                showCancelButton: true,
                customClass: { confirmButton: 'btn btn-danger me-2', cancelButton: 'btn btn-label-secondary' },
                buttonsStyling: false,
                confirmButtonText: 'نعم، إلغاء الحجز',
                cancelButtonText: 'تراجع',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelBooking(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الإلغاء',
                                err.response?.data || 'حدث خطأ غير متوقع');
                        });
                }
            });
        },

        // ------------------------------------------------------------------
        //  Delete
        // ------------------------------------------------------------------
        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteBooking(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الحذف',
                                err.response?.data || 'حدث خطأ غير متوقع');
                        });
                }
            });
        },

    }
};